import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import Accordion from '../../../../components/Accordion/Accordion'
import Buttons from '../../../../components/ui/button/Buttons'
import FormCreator from '../../../../components/Forms/FormCreator'
import { BusinessActivityData } from './BusinessActivity.data'
import { useUpdateCorporateMemberBusinessActivityByAdminMutation } from '../../../../app/services/corporateMembership/corporateMemberApi'
import ToastService from '../../../../services/toastService/ToastService'
import SwalAlert from '../../../../services/swalService/SwalService'
import { filterDropDownList, setAllDropDownFieldForBusinessActivity } from './utils/DropdownUtils'
import { applyProductServiceInitialState, toggleFieldVisibilityWithLabel } from './utils/BusinessUtils'

const BusinessActivity = forwardRef((props, ref) => {
  const [formData, setFormData] = useState(BusinessActivityData);
  const { error, success } = SwalAlert();
  const triggerMap = { 12: "Others; Please specify", 18: "Others; Please specify", 38: "Others; Please specify" };
  const [updateBusinessActivityByAdmin, { data: updateBusinessActivityByAdminData, isLoading: updateBusinessActivityByAdminLoading, isError: updateBusinessActivityByAdminIsError, error: updateBusinessActivityByAdminError, }] = useUpdateCorporateMemberBusinessActivityByAdminMutation();


  const handleFormFieldChange = (dataField, value) => {
    let form = { ...formData };
    form.initialState = { ...form.initialState };
    if (dataField === "organisationCategory") {
      const selectedValue = value?.value ?? null;
      let updatedFormData = {...formData,initialState: {...formData.initialState, organisationCategory: selectedValue, productsandServicesOfferedbyOrganisation: null, otherproductsandServices: null,}};const updatedProductServiceOptions = props?.dropDownList ? filterDropDownList(`org${selectedValue}`, props?.dropDownList) : [];
      updatedFormData = {...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "productsandServicesOfferedbyOrganisation" ? {...field, fieldSetting: { ...field.fieldSetting, options: updatedProductServiceOptions, },} : field),};
      updatedFormData = {...updatedFormData,formFields: updatedFormData.formFields.map(field =>field.id === "otherproductsandServices" ? { ...field, validation: [], style: { ...field.style, containerCss: "col-md-6 mb-3", },  fieldSetting: { ...field.fieldSetting, isDisable:true, }} : field),};
      setFormData(updatedFormData);
    } else if (dataField === "productsandServicesOfferedbyOrganisation") {
      const selectedValue = value ?? null;
      let updatedFormData = {...formData,initialState: {...formData.initialState,productsandServicesOfferedbyOrganisation: selectedValue,},};
      updatedFormData = toggleFieldVisibilityWithLabel(updatedFormData, { dataFieldValue: selectedValue, triggerMap, targetFieldId: "otherproductsandServices" });
      setFormData(updatedFormData);
      return;
    } else {
      setFormData((prev) => ({ ...prev, initialState: { ...prev.initialState, [dataField]: value }, }));
    }
  }

  const handleSubmit = () => {
    const formData = ref.current.getFormData();
    if (!formData) {
      error("Please fill in all mandatory fields to continue.", "")
      return;
    }
    let req = {
      SGBCCorporateMemberId: props.id,
      OrganisationCategory: formData?.organisationCategory?.value || formData?.organisationCategory,
      OtherOrganisationCategory:  null,
      ProductsandServicesOfferedbyOrganisation: formData?.productsandServicesOfferedbyOrganisation.length > 0 ? formData?.productsandServicesOfferedbyOrganisation?.join(',') : null,
      OtherProductsandServices: formData?.otherproductsandServices || null,
      TypeOfProduct: formData?.typeOfProduct || null,
      AnnualTurnover: formData?.annualTurnover?.value || formData?.annualTurnover,
      NumberofEmployees: formData?.numberofEmployees?.value || formData?.numberofEmployees,
      CompanyDescription: formData?.companyDescription||null,
      DescribeTheWays: formData?.describeTheWays || null,
    }
    updateBusinessActivityByAdmin(req);
  }

  useEffect(() => {
    if (!updateBusinessActivityByAdminLoading && updateBusinessActivityByAdminData) {
      const isError = updateBusinessActivityByAdminData.keyId == 0;
      ToastService[isError ? "error" : "success"](isError ? "Record was not updated." : "Record updated successfully.");
    }
  }, [updateBusinessActivityByAdminData, updateBusinessActivityByAdminLoading])

  useEffect(() => {    
    const {
      organisationCategoryId: orgCategory, productsAndServiceByOrganisationId: productsAndServices,
      otherOrganisationCategory,
      typeOfProductAndService,
      annualTurnoverId,
      numberOfEmployeeId,
      descriptionOfCompanyInvolvedInGreenBuiding,
      companyDescription,
      otherProductsandServices
    } = props.corporateMemberDetails || {};

    if (orgCategory ) {
        const serviceOptions = filterDropDownList(`org${orgCategory}`, props.dropDownList);
        const convertedProducts =
        productsAndServices
          ? productsAndServices.split(",").map((x) => Number(x.trim()))
          : [];
       let updatedFormData = {...formData, formFields: formData.formFields.map(field => field.id === "productsandServicesOfferedbyOrganisation" ? {...field,fieldSetting: { ...field.fieldSetting, options: serviceOptions }} : field)};
       updatedFormData = applyProductServiceInitialState({ formData, dropdownData: props.dropDownList, orgCategory, convertedProducts,} );
       updatedFormData = { ...updatedFormData, formFields: updatedFormData.formFields.map(field => field.id === "otherproductsandServices" ? { ...field, fieldSetting: { ...field.fieldSetting, isDisable: !convertedProducts.includes(12), },  validation: convertedProducts.includes(12) ? [{ type: "require" }] : [], } : field ), };
     
      updatedFormData = {...updatedFormData,initialState: { ...updatedFormData.initialState,others: otherOrganisationCategory ?? null, typeOfProduct: typeOfProductAndService ?? null, annualTurnover: annualTurnoverId ?? null, numberofEmployees: numberOfEmployeeId ?? null, describeTheWays: descriptionOfCompanyInvolvedInGreenBuiding ?? null, companyDescription: companyDescription ?? null, otherproductsandServices:otherProductsandServices ?? null, productsandServicesOfferedbyOrganisation: convertedProducts.length ? convertedProducts : null,organisationCategory: orgCategory ?? null,},};
      setFormData( updatedFormData );
    }
  }, [props.id, props.corporateMemberDetails]);



  return (
    <>
      <Accordion title="Business Activity" button={false}>
        <div className="row">
          <FormCreator
            ref={ref}
            {...formData}
            onFormFieldValueChange={handleFormFieldChange}
          />
        </div>
        <div className="btn-right-side">
          <Buttons
            buttonText="Save"
            buttonTypeClassName="success-btn"
            onClick={handleSubmit}
            isLoading={updateBusinessActivityByAdminLoading}
          />
        </div>
      </Accordion>
    </>
  )
})

export default BusinessActivity
